module.exports = __webpack_public_path__ + "static/media/template2-carousel.e6b02468.webp";